import { SVGProps } from "react"

const ScrollBarAnchor = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="52"
    height="52"
    viewBox="0 0 52 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Control">
      <g id="Subtract" filter="url(#filter0_d_25757_10574)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14 4C10.6863 4 8 6.68629 8 10V34C8 37.3137 10.6863 40 14 40H38C41.3137 40 44 37.3137 44 34V10C44 6.68629 41.3137 4 38 4H14ZM14 22.0625L24.5 16.0003V28.1247L14 22.0625ZM39 22.0625L28.5 28.1247V16.0003L39 22.0625Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_25757_10574"
        x="0"
        y="0"
        width="52"
        height="52"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="4" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_25757_10574" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_25757_10574"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
export default ScrollBarAnchor
